import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import { CalendarView } from "../../services/scheduling/Scheduling.types";
import { moveCalendarAnchor, periodLabel } from "./calendar.utils";
import styles from "./ScheduleCalendar.module.css";

interface CalendarToolbarProps {
  anchorDate: Dayjs;
  view: CalendarView;
  onAnchorDateChange: (value: Dayjs) => void;
  onViewChange: (view: CalendarView) => void;
}

const views: CalendarView[] = ["day", "week", "month"];

export default function CalendarToolbar({
  anchorDate,
  view,
  onAnchorDateChange,
  onViewChange,
}: CalendarToolbarProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.toolbar}>
      <div className={styles.toolbarNavigation}>
        <button
          className={styles.primaryCommand}
          type="button"
          onClick={() => onAnchorDateChange(dayjs())}
        >
          {t("calendar.today")}
        </button>
        <button
          className={styles.iconCommand}
          type="button"
          aria-label={t("calendar.previousPeriod")}
          onClick={() =>
            onAnchorDateChange(moveCalendarAnchor(anchorDate, view, -1))
          }
        >
          ‹
        </button>
        <button
          className={styles.iconCommand}
          type="button"
          aria-label={t("calendar.nextPeriod")}
          onClick={() =>
            onAnchorDateChange(moveCalendarAnchor(anchorDate, view, 1))
          }
        >
          ›
        </button>
        <h2 className={styles.periodTitle}>{periodLabel(anchorDate, view)}</h2>
      </div>

      <div className={styles.viewSwitcher} aria-label={t("calendar.viewLabel")}>
        {views.map((candidate) => (
          <button
            key={candidate}
            type="button"
            aria-pressed={candidate === view}
            className={candidate === view ? styles.activeView : styles.viewButton}
            onClick={() => onViewChange(candidate)}
          >
            {t(`calendar.views.${candidate}`)}
          </button>
        ))}
      </div>
    </div>
  );
}
